import React from 'react'

import * as SC from './ConnectorLines.style'

interface CurvedConnectorLineProps {
  direction: 'up' | 'down'
  color?: string
}

export const CurvedConnectorLine: React.FC<CurvedConnectorLineProps> = ({ direction, color }) => {
  return (
    <SC.CurvedConnectorWrapper lineDirection={direction}>
      <svg
        fill={'none'}
        height={'53'}
        viewBox={'0 0 110 53'}
        width={'110'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M108 53V51.1197C108 40.074 99.0457 31.1197 88 31.1197H26.1197C16.1124 31.1197 8 23.0072 8 13V13'
          }
          stroke={color}
          strokeLinejoin={'round'}
          strokeWidth={'4'}
        />
        <circle cx={8} cy={8} fill={'white'} r={'6'} stroke={color} strokeWidth={'4'} />
      </svg>
    </SC.CurvedConnectorWrapper>
  )
}

interface StraightConnectorLineProps {
  color?: string
}

export const StraightConnectorLine: React.FC<StraightConnectorLineProps> = ({ color }) => {
  return (
    <SC.StraightConnectorWrapper>
      <svg
        fill={'none'}
        height={'63'}
        viewBox={'0 0 16 63'}
        width={'16'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <line stroke={color} strokeWidth={'4'} x1={'8'} x2={'8'} y1={'8.74231e-08'} y2={'55'} />
        <circle cx={'8'} cy={'55'} fill={'white'} r={'6'} stroke={color} strokeWidth={'4'} />
      </svg>
    </SC.StraightConnectorWrapper>
  )
}

export const DottedConnectorLine = () => {
  return (
    <SC.StraightConnectorWrapper>
      <SC.DottedLine />
    </SC.StraightConnectorWrapper>
  )
}
